import React from "react"
import { RenderElementProps } from "slate-react"

const CopytextQuote = ({ children, attributes }: RenderElementProps) => {
    return (
        <div
            {...attributes}
            className="mb-4 text-xl last:mb-0 sm:mb-5 sm:text-3xl/3xl lg:text-5xl/5xl"
        >
            {children}
        </div>
    )
}

export default CopytextQuote
